var _rect, _path, _rect2, _g, _rect3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg102(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 9,
    fill: "#D4213D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 8 36 17H11z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17.2,
    width: 25,
    height: 2,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: 20,
    width: 3.4,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.8,
    y: 20,
    width: 3.4,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2,
    y: 20,
    width: 3.4,
    height: 9
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 29.2,
    width: 26,
    height: 2.4,
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 23.5,
    y: 43,
    textAnchor: "middle",
    fontFamily: "Arial,Helvetica,sans-serif",
    fontSize: 9,
    fontWeight: 800,
    fill: "#fff"
  }, "PLN")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg102);
export default __webpack_public_path__ + "static/media/102.720fd59a8481a459ac40f7c1306c15e6.svg";
export { ForwardRef as ReactComponent };